import 'gsap'
import $ from 'jquery'



var transitionMixin = {

    data: () => ({
        // mobile: window.innerWidth <= 768
    // showVideo: false
    }),

    created: function() {
        var self = this;
    },

    computed: {
        mobile() {
            return this.$store.getters['app/getWidth'] <= 768;
        }
    },

    methods: {

        afterEnter: function(el, done) {},

        enter(el, done) {

            if(this.mobile){
                done();
                return;
            }

            const tl = new TimelineMax({
                onComplete: done
            })

            tl.set(el, {
                // y: 20,
                opacity: 0,
                // transformOrigin: '50% 50%'
            })

            tl.to(el, 1, {
                // y: 0,
                delay: 0.1,
                opacity: 1
            });
        },

        leave(el, done) {

            if(this.mobile){
                done();
                return;
            }

            $(el).addClass('transitioning-out');

            TweenMax.to(el, 1, {
                opacity: 0,
                delay: 0.1,
                y: -20,
                // height: 0,
                onComplete: done
            });

        }
    }
}


export default transitionMixin;


// WEBPACK FOOTER //
// ./src/mixins/transition.js